
<template>

    <div :class=" backDropClasses " @click=" toggleBackDrop "></div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'back-drop',
        methods: {

            ...mapActions({

                toggleBackDrop : 'backDropClicked'
            })
        },
        computed: {

            ...mapGetters({

                showBackDrop : 'showBackDrop'
            }),
            backDropClasses: function(){

                const classes = [ 'backdrop-base' ];
                classes.push( ( this.showBackDrop ) ? 'open' : 'closed' );
                return classes.join( " " );
            }
        }
    }
</script>

<style scoped>

    .backdrop-base {

        position: fixed;
        top: 0; bottom: 0; left: 0; right: 0;
        width: 100%;
        height: 100%;
        background-color: rgba( 0, 0, 0, 0.4 );
        transition: all 0.3s;
    }
    .open {

        z-index: 500;
        opacity: 1;
    }
    .closed {

        z-index: -1;
        opacity: 0;
        display: none;
    }
</style>